document.addEventListener('DOMContentLoaded', function() {
  let variantChanged = false;
  const jsonEl = document.getElementById('ProductJson');
  if (!jsonEl) return;

  let productData;
  try {
    productData = JSON.parse(jsonEl.textContent);
  } catch (err) {
    //console.error('Failed to parse ProductJson:', err);
    return;
  }

  const variants = productData.variants || [];
  //console.log(variants);

  const priceContainer = document.querySelector('#variantPrice');
  const variantButtons = document.querySelectorAll('.variant-btn');
  const variantIdField = document.getElementById('variantIdField');
  const variantImage = document.getElementById('variantMainImage');

  if (!variantButtons.length) return;

  // ✅ Set first variant active on load
  if (variantChanged === false) {
    $('[data-value="' + variants[0].title + '"]').addClass('active');

    const priceEl = priceContainer.querySelector('h4');
    const perOzEl = priceContainer.querySelector('h6');

    $('#lcdUnitPrice').html(accounting.formatMoney(variants[0].price / variants[0].content_qty));
    $('#lcdUnit').html(variants[0].content_unit);
    if(variants[0].content_qty>0){
    $('#lcdBlock').show();
} else {
    $('#lcdBlock').hide();
}
    priceEl.textContent = accounting.formatMoney(variants[0].price);
  }

  // ✅ Add click listeners to variant buttons
  variantButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      variantChanged = true;

      // reset active state
      variantButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const selectedOptions = [];
      document.querySelectorAll('.variant-buttons').forEach((group, idx) => {
        const active = group.querySelector('.active');
        selectedOptions[idx] = active ? active.dataset.value : null;
      });

      const matchedVariant = variants.find(v => v.title === selectedOptions[0]);
      //console.log(matchedVariant);

      if (matchedVariant) {
        const priceEl = priceContainer.querySelector('h4');
        const perOzEl = priceContainer.querySelector('h6');

        $('#lcdUnitPrice').html(accounting.formatMoney(matchedVariant.price / matchedVariant.content_qty));
        $('#lcdUnit').html(matchedVariant.content_unit);
if(matchedVariant.content_qty>0){
    $('#lcdBlock').show();
} else {
    $('#lcdBlock').hide();
}
        priceEl.textContent = accounting.formatMoney(matchedVariant.price);
        //console.log(priceEl.textContent);

        // update hidden input
        if (variantIdField)
          variantIdField.value = matchedVariant.id;

        // update image
        if (variantImage && matchedVariant.featured_image)
          variantImage.src = matchedVariant.featured_image.src;
      }
    });
  });
});





document.addEventListener("DOMContentLoaded", () => {
  // Only run if metaobject exists
  if (!window.PesticideMeta || !window.PesticideMeta.enhancement) return;

  const enhancement = window.PesticideMeta.enhancement;
  const handle = enhancement.enhancement_handle;

  if (!handle) return //console.warn("⚠️ No enhancement handle defined");

  // Intercept add-to-cart submits
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    form.addEventListener("submit", async e => {
      e.preventDefault();
      //console.log("🛒 Intercepted add-to-cart");

      const formData = new FormData(form);
      const res = await fetch("/cart/add.js", { method: "POST", body: formData });
      if (!res.ok) return;

      //console.log("✅ Product added to cart");

      // Fetch enhancement product
      try {
        const productRes = await fetch(`/products/${handle}.js`);
        const enhancementProduct = await productRes.json();

        // Render popup
        renderEnhancementPopup(enhancementProduct, enhancement);

      } catch (err) {
        //console.error("❌ Enhancement fetch failed:", err);
      }
    });
  });

  // 🔹 Render the popup
  function renderEnhancementPopup(product, enh) {
    document.getElementById("agcEnhAddBtn").onclick = async () => {
      console.log('adding to cart')
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: product.variants[0].id, quantity: 1 }),
        });
        modal.style.display = "none";
        window.location.reload();
      } catch (err) {
        console.error("Failed to add enhancement:", err);
      }
    };
    console.log('rendering')
    const image = product.images?.[0] || "";
    const title = product.title;
    const handle = product.handle;
    const price = accounting.formatMoney(product.price/100);
    const narrative =
      enh.narrative?.children
        ?.map(p => p.children.map(t => t.value).join(""))
        .join("<br>") ||
      "This product enhances your results and improves application effectiveness.";

     document.getElementById("agcEnhImage").src = product.images?.[0] || "";
    document.getElementById("agcEnhTitle").textContent = product.title;
    document.getElementById("agcEnhDesc").textContent =
      enh.narrative ||
      "This product enhances your results and improves application effectiveness.";
    document.getElementById("agcEnhPrice").textContent = accounting.formatMoney(
      product.price
    );

    const modal = document.getElementById("agcEnhancementModal");
    modal.style.display = "flex";
$('#agcEnhancementModal').modal('show')
    // Add enhancement on click
    document.getElementById("agcEnhAddBtn").onclick = async () => {
      console.log('adding to cart')
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: product.variants[0].id, quantity: 1 }),
        });
        modal.style.display = "none";
        window.location.reload();
      } catch (err) {
        console.error("Failed to add enhancement:", err);
      }
    };

    // Close modal
    $('#agcEnhancementModal').modal('hide')
    document.querySelector(".agc-close").onclick = () => {
      modal.style.display = "none";
    };

    window.onclick = (event) => {
      if (event.target === modal) modal.style.display = "none";
    };
  }

  
});

